import { render, staticRenderFns } from "./AdminManageAutoEmail.vue?vue&type=template&id=73faa23d"
import script from "./AdminManageAutoEmail.vue?vue&type=script&lang=js"
export * from "./AdminManageAutoEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports